export const DAILY_PAGES = {
  MONDAY: {
    id: 'market-focus',
    path: '/market-focus',
    pageId: 'DailyMarketsMonday',
    title: 'Market Focus',
  },
  TUESDAY: {
    id: 'daily-market-updates',
    path: '/daily-market-updates',
    pageId: 'DailyMarketsTuesday',
    title: 'Daily Market Updates',
  },
  WEDNESDAY: {
    id: 'daily-markets-wednesday',
    path: '/daily-markets-wednesday',
    pageId: 'DailyMarketsWednesday',
    title: 'Daily Markets Wednesday',
  },
  THURSDAY: {
    id: 'daily-markets-thursday',
    path: '/daily-markets-thursday',
    pageId: 'DailyMarketsThursday',
    title: 'Daily Markets Thursday',
  },
};

export default DAILY_PAGES;
